import { render } from "./IsLocationImportantSelector.vue?vue&type=template&id=765fae04&scoped=true"
import script from "./IsLocationImportantSelector.vue?vue&type=script&lang=js"
export * from "./IsLocationImportantSelector.vue?vue&type=script&lang=js"

import "./IsLocationImportantSelector.vue?vue&type=style&index=0&id=765fae04&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765fae04"]])

export default __exports__